import { when } from "hooks/useWhen";
import { PAYMENT_ARGS } from "consts/feature-config";
import {
  getGiftIncentiveRatio,
  getPaymentIncentiveRatio,
} from "consts/incentive-config";

export const calculateEstimate = (
  weight,
  _,
  featureFlags = [],
  takebackDate = null
) => {
  const showPayment = when(PAYMENT_ARGS);
  const giftRatio = getGiftIncentiveRatio(featureFlags, takebackDate);
  const paymentRatio = showPayment
    ? getPaymentIncentiveRatio(featureFlags, takebackDate)
    : 2.4;
  let payment, gift;

  payment = (weight * paymentRatio).toFixed(2);
  gift = (weight * giftRatio).toFixed(2);
  return { gift, payment, giftRatio };
};
